<template>
  <div class="ecircular-preview">
    <div
      class="ecircular-preview__header"
      v-html="dataSrc.header"
    />
    <div class="ecircular-preview__call-center">
      <img :src="callCenterLogo">
    </div>
    <br>
    <div
      class="ecircular-preview__description"
      v-html="dataSrc.description"
    />
    <div
      class="ecircular-preview__footer"
      v-html="dataSrc.footer"
    />
    <div class="ecircular-preview__logo">
      <img
        v-region-img-src="'email-logo-hkland.png'"
        :alt="$t('system.title')"
      >
    </div>
    <div
      :key="new Date().getTime()"
      v-html="dataSrc.signature"
    />
  </div>
</template>

<script>
import { getDoc } from '@/api/docs/request'
export default {
  name: 'ECircularPreview',
  props: {
    dataSrc: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      callCenterLogo: null,
    }
  },
  watch: {
    'dataSrc.callCenterImgId': {
      handler: async function (val) {
        if (val) {
          this.callCenterLogo = await getDoc(val, {includeDelete: true})
        } else {
          this.callCenterLogo = null
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
%template_P {
  margin-top: 1em;
  margin-bottom: 1em;
}
.ecircular-preview {
  background-color: #f2f6f8;
  padding: 35px 30px 30px 30px;
  label {
    margin-top: 0;
    margin-bottom: 0;
  }
  &__header {
    & ::v-deep p {
      @extend %template_P
    }
  }
  &__footer {
    & ::v-deep p  {
      @extend %template_P
    }
  }
  &__description {
    overflow: auto;
    p {
      margin-bottom: 0 !important;
    }
  }
  &__call-center {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 10px;
    & img {
      width: 181px; // same as the email template
    }
  }
  &__logo {
    margin-top: 1em;
    img {
      width: 163px;
    }
  }
}
</style>
